import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/ProductGallery.css";
import { Container, Row, Col, Button, Form, Image } from "react-bootstrap";
import service from "../assests/service-01.jpg";
import service1 from "../assests/service-02.jpg";
import service2 from "../assests/service-03.jpg";
import service3 from "../assests/service-04.png";
import service4 from "../assests/service-05.png";
import service5 from "../assests/service-06.webp";
import { Link } from "react-router-dom";
import GalleryData from "./GalleryData";
import logo from './../assests/logo_1.png';
import Footer from "./Footer";





// Updated array to handle both images and videos (total 15 media items)
const media = [
  { type: "image", src: service },
  { type: "image", src: service1 },
  { type: "image", src: service2 },
  { type: "video", src: "https://www.w3schools.com/html/mov_bbb.mp4" },
  { type: "image", src: service3 },
  { type: "video", src: service5 },
  { type: "image", src: service4 },
  { type: "image", src: "https://via.placeholder.com/300" },
  { type: "image", src: "https://via.placeholder.com/300" },
  { type: "video", src: "https://www.w3schools.com/html/mov_bbb.mp4" },
  { type: "image", src: "https://via.placeholder.com/300" },
  { type: "image", src: "https://via.placeholder.com/300" },
  { type: "video", src: "https://www.w3schools.com/html/movie.mp4" },
  { type: "image", src: "https://via.placeholder.com/300" },
  { type: "video", src: "https://www.w3schools.com/html/mov_bbb.mp4" },
];



function ProductGallery() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <div className="containerx">
      {" "}
      {/* Added margin from navbar */}
      <div className="row">
        <div className="about-page">
          {/* Navbar */}

          {/* Content below Navbar */}
          <div className="gallery-page ">
            <div className="overlay"></div>

            <div className="content-wrapper1">
              <h1>Product Gallery</h1>
              {/* <div className="breadcrumb1">
            <i className="fa-solid fa-house-chimney"></i>
            <Link><span className="me-3">Home </span></Link>
            <i className="fa-regular fa-address-card"></i>
            <span>About Us</span>
          </div> */}
            </div>
          </div>
        </div>
      </div>
      {/* <div className="px-5">
        <div className="row mt-5 ">
          {media.map((item, index) => (
            <div key={index} className="col-md-4 mb-4">
              <div
                className="img-container"
                style={{ width: "100%", height: "300px", overflow: "hidden" }}
              >
                {" "}
                {item.type === "image" ? (
                  <img
                    src={item.src}
                    alt={`Product ${index}`}
                    className="img-fluid product-img"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "15px",
                    }}
                  />
                ) : (
                  <video
                    controls
                    className="img-fluid product-video"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "15px",
                    }}
                  >
                    <source src={item.src} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                )}
              </div>
            </div>
          ))}
        </div>
      </div> */}
      <Container className="mt-5">
        {GalleryData.map((gallery, galleryIndex) => (
          <div key={galleryIndex}>
            <h2 className="main-heading text-center">
              {gallery.title}
            </h2>
            <Row>
              {gallery.images.map((image, imageIndex) => (
                <Col
                  key={imageIndex}
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  className="mb-4"
                >
                  <Image
                    src={image}
                    alt={`Image ${imageIndex + 1}`}
                    className=" product-img"
                  />
                </Col>
              ))}
            </Row>
          </div>
        ))}
      </Container>
      <Footer />
    </div>
  );
}

export default ProductGallery;
